import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TripConsentStatus from "./TripConsentStatus";
import TripList from "./TripList";

const tabs = [
  { key: "forms", label: "Consent Forms" },
  { key: "status", label: "Consent Status" },
];

/**
 * Consent-form hub for admin and instructor. `basePath` is passed by each
 * role's route so the same components serve both shells.
 */
const SwitchTrip = ({ basePath = "/dashboard/admin/menu/consent-form" }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentTab = location.pathname.split("/").pop() || "forms";
  const [selectedTripId, setSelectedTripId] = useState(null);

  const openRoster = (tripId) => {
    setSelectedTripId(tripId);
    navigate(`${basePath}/status`);
  };

  return (
    <div className="p-8">
      <div
        className="bg-white rounded-lg"
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${tabs.length}, 1fr)`,
        }}
      >
        {tabs.map(({ key, label }) => (
          <div
            key={key}
            onClick={() => navigate(`${basePath}/${key}`)}
            className={`iskool-tab-item ${
              currentTab === key ? "bg-gray-600 text-white shadow" : ""
            }`}
          >
            <div className="text-lg">{label}</div>
          </div>
        ))}
      </div>

      {/* Both panels stay mounted so filters survive a tab switch — same as SwitchFee. */}
      <div
        style={{
          display: currentTab === "status" ? "none" : "block",
        }}
      >
        <TripList onViewRoster={openRoster} />
      </div>
      <div style={{ display: currentTab === "status" ? "block" : "none" }}>
        <TripConsentStatus
          tripId={selectedTripId}
          onTripChange={setSelectedTripId}
        />
      </div>
    </div>
  );
};

export default SwitchTrip;
